<script lang="ts">
  import { _ } from "svelte-i18n";
  import { socialMedia } from "$lib/data/footer.data";
  import Typography from "$lib/components/Typography/Typography.svelte";
  import Container from "$lib/components/Container/Container.svelte";
  import FooterIcons from "../FooterIcons/FooterIcons.svelte";
  import { processInlineLinks } from "$lib/utils/url";

  export let isPdpOrPlp;
</script>

<style lang="scss">
  .subfooter {
    background-color: $surface;
    color: $on-surface;

    &--wrapper {
      display: flex;
      flex-direction: column;
      padding: 24px 0;

      @include breakpoint(lg) {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }
      &__extended {
        padding-bottom: 72px;

        @include breakpoint(md) {
          padding-bottom: 88px;
        }
      }
    }

    &--socials {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-top: 24px;

      @include breakpoint(md) {
        flex-direction: row;
        align-items: center;
        justify-content: left;
      }

      @include breakpoint(lg) {
        padding-top: 0;
        padding-right: 90px;
      }
    }
  }
</style>

<div class="subfooter">
  <Container>
    <div
      class={`subfooter--wrapper ${
        isPdpOrPlp && "subfooter--wrapper__extended"
      }`}
    >
      <div class="subfooter--address">
        <Typography theme="on-surface"
          >{@html processInlineLinks($_("footer.address"))}</Typography
        >
      </div>
      <div class="subfooter--socials">
        <Typography variant="overline" theme="on-surface"
          >{$_("footer.followUs")}</Typography
        >
        <FooterIcons links={socialMedia} slot="item" />
      </div>
    </div>
  </Container>
</div>
